import { setAnalysisLoading, setAnalysisErrorMessage, setAnalysisBandData } from '../';
import { getBandData } from '../../../../../api/groupsAPI';
import { getSelectedTrend } from '../selectors';
import { addOrdinalToGradePoints } from '../../../../../utils/groups';
import { translate } from '../../../../../utils/locale';

/**
 * Fetch Group Data
 */
export const fetchBandData = (examLevel: Analysis.Gradepoint): AppThunk => async (
	dispatch,
	getState
) => {
	dispatch(setAnalysisLoading('AnalysisBandData'));

	try {
		const selectedTrend = getSelectedTrend(getState());
		const selectedTrendGradePoints = [...selectedTrend?.gradepoints] ?? [];
		const groupRes = await getBandData(examLevel);
		const responseObject = groupRes.responseObject;

		responseObject.gradepoints = addOrdinalToGradePoints(
			responseObject.gradepoints,
			selectedTrendGradePoints
		);

		dispatch(setAnalysisBandData(groupRes.responseObject));
	} catch (err: any) {
		dispatch(
			setAnalysisErrorMessage(err?.message ?? translate('groups.errors.FAILED_TO_FETCH_DATA'))
		);
	}
};
